/**
 * 상품을 공개하기까지 채우는 순서 — 수정 화면의 섹션 순서와 같다.
 * anchorId 는 수정 화면에서 그 섹션을 감싸는 요소의 id 로, 등록 순서의 단계를 누르면 그 섹션으로 간다.
 */
export const SETUP_STEPS = [
  {
    key: 'basic',
    title: '기본 정보',
    note: '이름·수량·실측·제작 조건',
    anchorId: 'product-step-basic',
  },
  {
    key: 'category',
    title: '카테고리·색상',
    note: '분류와 색상별 사진',
    anchorId: 'product-step-category',
  },
  {
    key: 'print',
    title: '인쇄 방식·이미지',
    note: '인쇄 방식과 대표 사진',
    anchorId: 'product-step-print',
  },
  { key: 'price', title: '가격', note: '수량 구간별 단가', anchorId: 'product-step-price' },
  {
    key: 'editArea',
    title: '편집영역',
    note: '사진 위 인쇄 영역·원통 표면',
    anchorId: 'product-step-edit-area',
  },
  {
    key: 'publish',
    title: '공개',
    note: '조건을 다 채우면 발행',
    anchorId: 'product-step-publish',
  },
] as const;
